import { render } from "./file-chart-pie-icon.vue.js?vue&type=template&id=89ca5b22!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./file-chart-pie-icon.vue?vue&type=template&id=89ca5b22"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__